export const iconFontAwesomeFoodBeverageWineGlass = (
	<i className="fa-solid fa-wine-glass"></i>
);
